import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { NIGERIAN_STATES, getCitiesForState } from '@/lib/nigeriaLocations';

interface StateCitySelectProps {
  stateValue: string;
  cityValue: string;
  onStateChange: (state: string) => void;
  onCityChange: (city: string) => void;
  stateLabel?: string;
  cityLabel?: string;
  disabled?: boolean;
}

export function StateCitySelect({
  stateValue,
  cityValue,
  onStateChange,
  onCityChange,
  stateLabel = 'State',
  cityLabel = 'City',
  disabled,
}: StateCitySelectProps) {
  const cities = getCitiesForState(stateValue);

  return (
    <div className="grid md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label>{stateLabel}</Label>
        <Select
          value={stateValue}
          onValueChange={(nextState) => {
            // IMPORTANT: reset city when state changes
            onStateChange(nextState);
            onCityChange('');
          }}
          disabled={disabled}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select state" />
          </SelectTrigger>
          <SelectContent>
            {NIGERIAN_STATES.map((state) => (
              <SelectItem key={state} value={state}>
                {state}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>{cityLabel}</Label>
        <Select
          value={cityValue}
          onValueChange={onCityChange}
          disabled={disabled || !stateValue}
        >
          <SelectTrigger>
            <SelectValue placeholder={stateValue ? 'Select city' : 'Select state first'} />
          </SelectTrigger>
          <SelectContent>
            {cities.map((city) => (
              <SelectItem key={city} value={city}>
                {city}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
